import Vue from 'vue'
import Toast from './toast.vue'

const ToastConstructor = Vue.extend(Toast)

const install = (Vue) => {
  const toastInstance = new ToastConstructor()
  const vm = toastInstance.$mount(document.createElement('div'))
  document.body.appendChild(vm.$el)

  Vue.prototype.$toast = (message, duration = 2500) => {
    vm.showToast(message, duration)
  }
}

export default { install }
